import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const Arrow = styled.span`
  color: ${props => props.theme.secondaryColor};
  font-size: 13px;
`;

export default function DropdownArrow({ expanded }) {
  const iconClass = {
    'fa-chevron-down': !expanded,
    'fa-chevron-up': expanded,
  };
  return <Arrow className={classNames('fa', iconClass)} />;
}

DropdownArrow.propTypes = {
  expanded: PropTypes.bool.isRequired,
};
